import { Fragment, memo } from "react";
import { useTranslation } from "react-i18next";
import EmptyInventory from "~/components/empty-states/empty-inventory";
import formatDate from "../../../catalogue/utils/formatDate";
import DateOffer from "~/components/DateOffer";
import { ProductCard } from "@components-monorepo/components/product-card";
import { ProductsGrid } from "@components-monorepo/components/products-grid";
import { MainPromotionsTypes } from "../../promotions.type";
import styles from "./CatalogueMainPromotions.module.css";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useOutletContext } from "@remix-run/react";

const CatalogueMainPromotions = ({ promotions }: MainPromotionsTypes) => {
  const { t } = useTranslation();
  const { theme } = useGlobalStyles();
  const { cartProducts, removeProduct, manuallyChangeProduct, addProduct } = useCart();
  const { storeMetadata } = useOutletContext<any>();
  const cart = {
    cartProducts,
    removeProduct,
    manuallyChangeProduct,
    addProduct
  };

  return (
    <div className={styles.wrapperCatalogueMainPromotions}>
      <section>
        {!!promotions.length ?
        promotions.map((offers, index) => {
          return offers.details && !!offers.details[0] ?
          <div key={`catalogue-container-${index}`} className={styles.promotionSection}>
                <div className={styles.headerAllPromotions} key={`catalogue-header-${index}`}>
                  <p className={styles.offersTitle}>{offers.title}</p>
                  {offers.localDateTo === "" && offers.localDateFrom === "" ?
              <DateOffer styleClass={styles.allTime}>{t("cataloguePromotionsMain.all_time")}</DateOffer> :

              <DateOffer>
                      {offers?.localDateFrom !== null && offers?.localDateTo !== null &&
                <>
                          {formatDate(offers.localDateFrom)} al {formatDate(offers.localDateTo)}
                        </>}

                    </DateOffer>}

                </div>
                <ProductsGrid className={styles.grid} theme={theme}>
                  {offers.details.map((detail: any, i: number) =>
              <Fragment key={`offer-${index}-product-${i}`}>
                      {detail && detail.product &&
                <ProductCard
                  key={`catalogue-main-products-product-${detail.product.id}`}
                  product={detail.product}
                  theme={theme}
                  addProduct={cart.addProduct}
                  removeProduct={cart.removeProduct}
                  manuallyChangeProduct={cart.manuallyChangeProduct}
                  cartProducts={cart.cartProducts}
                  locale={storeMetadata?.locale}
                  currency={storeMetadata?.currency} />}


                    </Fragment>
              )}
                </ProductsGrid>
              </div> :
          null;
        }) :

        <EmptyInventory texNotInventory={t("noInventory.text")} />}

      </section>
    </div>);

};

export default memo(CatalogueMainPromotions);